import {
    SkyNetTableConfig,
} from 'app/shared-components/SkyNetTable'
import {
    FilterType,
    CommonRoutes,
} from 'app/enums/common.enums'
import {
    DeliveryServiceType,
    CollectionServiceType,
} from 'app/enums/label.enums'
import {
    lanes,
} from '../Dashboard.types'

const config: SkyNetTableConfig<keyof lanes> = {
    name: 'lanesToBePriced',
    tabs: [{
        name: 'To Be Priced',
        url: CommonRoutes.All,
        fields: [
            {
                name: 'laneNumber',
                labelKey: 'AccountLane.laneNumber',
            },
            {
                name: 'laneGroupNumber',
                labelKey: 'LaneGroup.laneGroupNumber',
            },
            {
                name: 'customerQuotation',
                labelKey: 'LaneGroupView.customerQuotationLocationName',
                filterField: 'customerQuotation',
                filterType: FilterType.Array,
            },
            {
                name: 'customerExecution',
                labelKey: 'LaneQuoteRequest.selectedCustomerExecution',
            },
            {
                name: 'pricingAccountCompanyName',
                labelKey: 'Lane.pricingAccount',
                filterField: 'pricingAccountCompanyName',
                filterType: FilterType.Array,
            },
            {
                name: 'consignee',
                labelKey: 'Order.consignee',
            },
            {
                name: 'deliveryServiceType',
                labelKey: 'Order.deliveryServiceType',
                componentName: 'EnumValue',
                allowedValuesEnum: DeliveryServiceType,
                filterField: 'deliveryServiceType',
                filterType: FilterType.Array,
            },
            {
                name: 'collectionServiceType',
                labelKey: 'LaneGroup.collectionServiceType',
                filterType: FilterType.Array,
                filterField: 'collectionServiceType',
                componentName: 'EnumValue',
                allowedValuesEnum: CollectionServiceType,
            },
            {
                name: 'originAirport',
                labelKey: 'OrderView.from',
                filterField: 'originAirport',
                filterType: FilterType.Array,
            },
            {
                name: 'destinationAirport',
                labelKey: 'OrderView.to',
                filterField: 'destinationAirport',
                filterType: FilterType.Array,
            },
            {
                name: 'temperatureRange',
                labelKey: 'PriceDashboard.temp',
            },
            {
                name: 'changedOn',
                labelKey: 'KamDashboard.lastUpdated',
                componentName: 'DateTimeCell',
            },
        ],
    }],
}

export default config
